import React from 'react';
import { TextInput } from '@mantine/core';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import ButtonLinkField from '../../../puck/fields/ButtonLinkField';

/**
 * Liste de liens libellé + cible, partagée par le pied de page et le menu.
 * La cible passe par le sélecteur du bouton : un lien pointe le plus souvent
 * une page du site, que l'URL libre obligeait à connaître par cœur.
 */
export default function LinkListField({ value, onChange }) {
  return (
    <CollapsibleListField
      value={value}
      onChange={onChange}
      addLabel="Ajouter un lien"
      createItem={(count) => ({ label: `Lien ${count + 1}`, url: '' })}
      itemTitle={(link, index) => link.label || `Lien ${index + 1}`}
      renderItem={(link, update) => (
        <>
          <TextInput
            size="xs"
            label="Libellé"
            value={link.label || ''}
            onChange={(e) => update({ label: e.target.value })}
          />
          <ButtonLinkField
            value={link.target}
            onChange={(target) => update({ target })}
            legacyUrl={link.url}
          />
        </>
      )}
    />
  );
}
